import "@/component-library/themes/global-styles/dynamic-styles/_root-scale.css";
import "@/component-library/themes/global-styles/dynamic-styles/body.css";
import "@/component-library/themes/global-styles/dynamic-styles/interactive.css";
import "@/component-library/themes/global-styles/dynamic-styles/scroll.css";
import "@/component-library/themes/global-styles/dynamic-styles/text.css";
import "@/component-library/themes/global-styles/dynamic-styles/text-headings.css";
